import { GET_ALL_GRUPOS_DE_ROTAS, GET_SPECIFIC_GRUPO_DE_ROTAS, GET_GRUPO_DE_ROTAS_USE } from './mutation-types'

export default {
 [GET_ALL_GRUPOS_DE_ROTAS]: (state, gruposDeRotas) => {
    state.gruposDeRotas = gruposDeRotas
 },
 [GET_SPECIFIC_GRUPO_DE_ROTAS]: (state, grupoDeRotas) => {
  state.grupoDeRotas = grupoDeRotas
 }, 
 [GET_GRUPO_DE_ROTAS_USE]: (state, grupoDeRotasUse) => {
   state.grupoDeRotasUse = grupoDeRotasUse
 }
}